import React, { useState } from 'react';

export default function SetupBanner({ onDismiss }) {
  const [open, setOpen] = useState(true);
  if (!open) return null;

  return (
    <div style={{
      background: 'linear-gradient(135deg, rgba(255,209,102,0.12) 0%, rgba(13,13,18,0) 80%)',
      border: '1px solid rgba(255,209,102,0.3)',
      borderRadius: '10px',
      padding: '18px 22px',
      marginBottom: '24px',
      display: 'flex',
      gap: '16px',
      alignItems: 'flex-start',
    }}>
      <div style={{ fontSize: '22px', flexShrink: 0 }}>⚙️</div>
      <div style={{ flex: 1 }}>
        <div style={{ fontFamily: 'var(--font-display)', fontSize: '14px', fontWeight: '800', color: 'var(--accent-gold)', marginBottom: '6px' }}>
          Connect Your Databases
        </div>
        <div style={{ fontSize: '12px', color: 'var(--text-3)', lineHeight: '1.7', marginBottom: '12px' }}>
          The dashboard is showing demo data. To see real live stats from your Supabase databases,
          add these 5 environment variables to your Cloudflare Pages project:
        </div>
        <div style={{
          background: 'var(--bg)',
          border: '1px solid var(--border)',
          borderRadius: '6px',
          padding: '12px 16px',
          fontFamily: 'var(--font-mono)',
          fontSize: '11px',
          color: 'var(--accent-m)',
          lineHeight: '2',
          marginBottom: '12px',
        }}>
          REACT_APP_MEDUVITA_SUPABASE_URL = https://xxx.supabase.co<br/>
          REACT_APP_MEDUVITA_SUPABASE_ANON_KEY = eyJ...<br/>
          REACT_APP_MMF_SUPABASE_URL = https://yyy.supabase.co<br/>
          REACT_APP_MMF_SUPABASE_ANON_KEY = eyJ...<br/>
          REACT_APP_RESEND_API_KEY = re_...
        </div>
        <div style={{ fontSize: '11px', color: 'var(--text-3)' }}>
          Cloudflare Pages → your project → <strong style={{color:'var(--text-2)'}}>Settings → Environment variables → Add variable</strong> → Redeploy.
          Use the <strong style={{color:'var(--text-2)'}}>anon key</strong> (not service_role) — found in Supabase → Settings → API.
        </div>
      </div>
      <div
        style={{ cursor: 'pointer', color: 'var(--text-3)', fontSize: '18px', flexShrink: 0, lineHeight: 1 }}
        onClick={() => setOpen(false)}
      >×</div>
    </div>
  );
}
